module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    staticClass: "confirmation-modal",
    attrs: {
      "width": "800px",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('strong', [_vm._v("お知らせ")])]), _vm._v(" "), _c('center', [(_vm.loginExpireDays < 31) ? _c('table', {
    staticStyle: {
      "width": "90%",
      "max-width": "400px",
      "text-align": "center",
      "background": "white",
      "font-weight": "bold",
      "border": "#404040 1px solid"
    }
  }, [_c('tr', {
    staticStyle: {
      "background": "#b4d5f1"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("パスワード通知")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "12px",
      "padding": "4px",
      "border": "#404040 1px solid",
      "text-align": "left"
    }
  }, [_vm._v(" パスワード有効期限まで残り")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-size": "12px",
      "padding": "4px",
      "border": "#404040 1px solid",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.loginExpireDays) + "日")])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-body notice-modal-body",
    staticStyle: {
      "height": "280px",
      "padding": "5px 15px",
      "overflow-x": "auto"
    }
  }, [_c('div', _vm._l((_vm.listOfNotices), function(n) {
    return _c('div', {
      key: n.seq_id
    }, [(_vm.processImportance(n.importance).length > 0) ? _c('div', [_c('span', {
      staticClass: "message_label"
    }, [_vm._v("重要度: ")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.processImportance(n.importance))
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "message_label"
    }, [_vm._v("送信者: ")]), _vm._v("\n            " + _vm._s(n.from_user_shimei || n.from_user) + "\n            "), _c('span', {
      staticClass: "message_label"
    }, [_vm._v("宛先: ")]), _vm._v(_vm._s(_vm.processnToUserShimei(n)) + "\n          ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "message_label"
    }, [_vm._v("登録日: ")]), _vm._v(" " + _vm._s(n.create_date) + "\n          ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "5px"
      },
      domProps: {
        "innerHTML": _vm._s(n.message)
      }
    }), _vm._v(" "), _c('hr')])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('yes')
      }
    }
  }, [_vm._v("\n        完了\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bca0fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/notice-modal.vue
// module id = 927
// module chunks = 0